import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';
import { useActiveUserContext } from '@vivli/core/infrastructure/context';

export function useAwaitingActionDetails() {
    const { user: activeUser, hasPermission, hasAnyPermissionForAnyOrg, hasAnyPermissionForOrg } = useActiveUserContext();
    const orgIds = activeUser?.orgMemberships?.map((m) => m.orgId) || [];
    const isVivliAdmin = hasPermission(PermissionsEnum.CreateOrg);
    const canViewAnOrg = isVivliAdmin || hasAnyPermissionForAnyOrg([PermissionsEnum.ListMyOrgs]);
    const canViewOrgInfo = isVivliAdmin || hasAnyPermissionForAnyOrg([PermissionsEnum.ListUsers]);
    const canViewEnquiryOrgInfo =
        isVivliAdmin || (orgIds.length > 0 && hasAnyPermissionForOrg(orgIds[0], [PermissionsEnum.EnqProviderAct]));
    const studiesLabel = isVivliAdmin ? 'Total Number of Studies' : 'Number of My Studies';

    const exportColumnKeys = [
        {
            url: 'datarequests',
            keys: [
                'vivliId',
                'title',
                'leadInvestigatorFullName',
                'leadInvestigatorAffiliation',
                'leadInvestigatorCountry',
                'contributors',
                'daysLeft',
                'currentWorkflowStepTargetDays',
                'numberOfStudies',
                'numberOfMyStudies',
                'requestAdminFullName',
                'actionText',
                'daysWarning'
            ]
        },
        {
            url: 'disclosures',
            keys: [
                'vivliId',
                'title',
                'disclosureType',
                'leadInvestigatorFullName',
                'contributors',
                'daysLeft',
                'actionText',
                'requestAdminFullName'
            ]
        },
        {
            url: 'uploads',
            keys: ['studyId', 'uniqueId', 'title', 'dataRequestId', 'requestType', 'availability', 'actionText']
        },
        {
            url: 'enquiries',
            keys: ['vivliId', 'numberOfStudies', 'numberOfMyStudies', 'daysLeft', 'requester', 'actionText', 'daysWarning']
        }
    ];

    return {
        isVivliAdmin,
        canViewAnOrg,
        canViewOrgInfo,
        exportColumnKeys,
        studiesLabel,
        canViewEnquiryOrgInfo
    };
}
